export default __webpack_public_path__ + "ZurichPro-TermsOfUse-September-2020.pdf";